import { SVGProps } from "react";

export const LinerGradient = (props: SVGProps<SVGLinearGradientElement>) => {
  return (
    <defs>
      <linearGradient x1="100%" x2="0%" y1="50%" y2="50%" {...props}>
        <stop offset="0" stopColor="#B647B7" />
        <stop offset="1" stopColor="#F683B6" />
      </linearGradient>
    </defs>
  );
};
